import React from 'react'
import { FormTextField } from '@fs/zion-form'
import { useTranslation } from 'react-i18next'

export default function PlaylistDescriptionTextField({ disabled }) {
  const [t] = useTranslation()
  return (
    <FormTextField
      label={t('common-ui:description.label', 'Description')}
      placeholder={t('playlists.form.description.placeholder', 'Playlist description...')}
      name="description"
      data-testid="playlist-description-input"
      disabled={disabled}
    />
  )
}
